const MIN_DIGITS_TO_APPLY_TON_FORMAT = 5;

export const PROJECTS_TYPE_NAMES_TOTAL_IMPACT = {
  EPCM: 'epcm',
  RE2020: 're2020',
  NOOCO: 'nooco',
  BBCA: 'bbca',
  PROJECT_SIMULATOR: 'projectSimulator',
};

export const percentReduce = (data) => {
  let dataValue = [];
  data.map((objecData) => {
    Object.keys(objecData).forEach((key) => {
      if (typeof objecData[key] === 'number') {
        dataValue.push(objecData[key]);
      }
    });
  });

  return dataValue.reduce((acc, curr) => acc + curr, 0);
};

export const getUnitConversion = (number, legend = false) => {
  const isLongerThanMinDigits =
    number.toString().split('.')[0].length >= MIN_DIGITS_TO_APPLY_TON_FORMAT;

  const unit = isLongerThanMinDigits ? 't' : 'kg';
  return legend ? unit : `${unit} éq CO₂`;
};

export const getFormattedWeightNumber = (number) => {
  let formattedNumber;
  const lengthNumber = number.toString().split('.')[0].length;

  if (lengthNumber >= MIN_DIGITS_TO_APPLY_TON_FORMAT) {
    formattedNumber = number / 1000;
  } else {
    formattedNumber = number;
  }

  return formattedNumber.toLocaleString('fr-FR', {
    maximumFractionDigits: 2,
  });
};

export const handleResize = (parentRef, setDimensions) => {
  if (parentRef.current) {
    setDimensions({
      width: parentRef.current.offsetWidth,
      height: parentRef.current.offsetHeight,
    });
  }
};
